import React from 'react'
import { LoadingSpinnerBase } from './LoadingSpinnerBase'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  isWhite?: boolean
  spinnerColor?: string
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
  isWhite = false,
  spinnerColor
}) => {
  return (
    <div className='h-screen flex items-center justify-center'>
      <LoadingSpinnerBase size={size} className={className} isWhite={isWhite} spinnerColor={spinnerColor} />
    </div>
  )
}
